import { render, staticRenderFns } from "./ViewEstablishmentPage.vue?vue&type=template&id=732b7358"
import script from "./ViewEstablishmentPage.vue?vue&type=script&lang=js"
export * from "./ViewEstablishmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports